import { useNavigate } from 'react-router-dom'
import { EuDropdownMenu, type EuDropdownSection } from '@newamsterdam/ui'
import { useUser } from '../store/user'
import { useCompanyPicker } from '../store/companyPicker'
import styles from './UserMenu.module.css'

export function UserMenu() {
  const navigate = useNavigate()
  const user = useUser()
  const openCompanyPicker = useCompanyPicker((s) => s.openManual)

  const currentCompany = user.companies.find((c) => c.id === user.current_company_id)
  const initial = (user.name?.trim()?.[0] ?? '?').toUpperCase()
  const displayName = user.name ?? '—'

  const sections: EuDropdownSection[] = []

  const profileItems = []
  if (user.email) {
    profileItems.push({
      id: 'profile-email',
      label: user.email,
      disabled: true,
      onClick: () => undefined,
    })
  }
  if (profileItems.length > 0) {
    sections.push({ label: displayName, items: profileItems })
  }

  if (user.companies.length > 0) {
    const singleCompany = user.companies.length === 1
    sections.push({
      items: [
        {
          id: 'selected-company',
          label: `Wybrana firma: ${currentCompany?.name ?? '—'}`,
          disabled: singleCompany,
          onClick: () => {
            if (!singleCompany) openCompanyPicker()
          },
        },
      ],
    })
  }

  sections.push({
    items: [
      {
        id: 'settings',
        label: 'Ustawienia',
        onClick: () => navigate('/settings'),
      },
      {
        id: 'logout',
        label: 'Wyloguj',
        danger: true,
        onClick: () => {
          void user.logout()
        },
      },
    ],
  })

  const trigger = (
    <button type="button" className={styles.trigger} aria-label="Menu użytkownika">
      <span className={styles.initial} aria-hidden="true">
        {initial}
      </span>
      <span className={styles.text}>
        <span className={styles.name}>{displayName}</span>
        {currentCompany && <span className={styles.company}>{currentCompany.name}</span>}
      </span>
      <span className={styles.caret} aria-hidden="true">
        ▾
      </span>
    </button>
  )

  return <EuDropdownMenu trigger={trigger} sections={sections} align="left" placement="top" />
}
